import { render, staticRenderFns } from "./habitCreateButton.vue?vue&type=template&id=c6fa2b84&scoped=true"
import script from "./habitCreateButton.vue?vue&type=script&lang=js"
export * from "./habitCreateButton.vue?vue&type=script&lang=js"
import style0 from "./habitCreateButton.vue?vue&type=style&index=0&id=c6fa2b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fa2b84",
  null
  
)

export default component.exports